var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M5 28c0 13.807 11.193 25 25 25 5.831 0 11.434-2.192 15.91-5.972-.957.108-1.924.163-2.898.163C28.872 47.191 17.5 36.028 17.5 22a25.456 25.456 0 0 1 8.06-18.607C13.871 5.488 5 15.708 5 28zM31.288 2.785A22.482 22.482 0 0 0 20.5 22c0 12.359 10.017 22.191 22.512 22.191 2.414 0 4.775-.38 7.02-1.116 1.427-.468 2.58 1.217 1.627 2.377C46.275 52.007 38.37 56 30 56 14.536 56 2 43.464 2 28S14.536 0 30 0c.178 0 .356.002.534.005 1.5.028 2.034 1.998.754 2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.a87c12b21ee6d5be208ddcf52d36e80c.svg";
export { ForwardRef as ReactComponent };